import React, { useState, createContext, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Wizard from './components/Wizard';
import Dashboard from './components/Dashboard';
import Nominees from './components/Beneficiaries';
import Account from './components/Account';
import AdminToolbar from './components/AdminToolbar';
import AuditLog from './components/AuditLog';
import DemoSwitcher from './components/AdminToolbar'; // reuse
import Login from './components/Login';
import Register from './components/Register';
import Profile from './components/Profile';
import FinancialAssets from './components/FinancialAssets';
import LegalAssets from './components/LegalAssets';
import OtherAssets from './components/OtherAssets';
import NomineeRegister from './components/NomineeRegister';
import AuthCallback from './components/AuthCallback';
import Logout from './components/Logout';
import api from './utils/api';

export const UserContext = createContext();

function App() {
  // Auth state
  const [currentUser, setCurrentUser] = useState(null);
  const [users, setUsers] = useState([]);

  // Fetch users only after sign-in so Authorization header is present
  useEffect(() => {
    if (!currentUser) return;
    api.get('/auth/users')
      .then(res => setUsers(res.data))
      .catch(() => {});
  }, [currentUser]);

  // Hydrate currentUser from localStorage on first load
  useEffect(() => {
    try {
      const stored = typeof window !== 'undefined' ? window.localStorage.getItem('currentUser') : null;
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed && parsed.id && parsed.email) {
          const normalized = { ...parsed };
          if (!normalized.type) {
            const ctx = normalized.active_context || (normalized.role === 'nominee' ? 'nominee' : 'owner');
            normalized.type = ctx;
          }
          setCurrentUser(normalized);
          try { window.localStorage.setItem('currentUser', JSON.stringify(normalized)); } catch {}
        }
      }
    } catch {}
  }, []);

  return (
    <UserContext.Provider value={{ currentUser, setCurrentUser, users, setUsers }}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register/nominee" element={<NomineeRegister />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/dashboard" element={currentUser ? <Dashboard /> : <Login />} />
          <Route path="/financial-assets" element={currentUser ? <FinancialAssets /> : <Login />} />
          <Route path="/legal-assets" element={currentUser ? <LegalAssets /> : <Login />} />
          <Route path="/other-assets" element={currentUser ? <OtherAssets /> : <Login />} />
          <Route path="/nominees" element={currentUser ? <Nominees /> : <Login />} />
          <Route path="/owners" element={currentUser ? <Nominees /> : <Login />} />
          <Route path="/account" element={currentUser ? <Account /> : <Login />} />
          <Route path="/audit" element={currentUser ? <AuditLog /> : <Login />} />
          <Route path="/profile" element={currentUser ? <Profile /> : <Login />} />
          <Route path="/onboard" element={<Wizard />} />
          <Route path="/" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </UserContext.Provider>
  );
}

export default App;